import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import VariablePricingTable from './variable-pricing-table';
import { FormattedMessage } from 'react-intl';

export default class VariablePricingTooltip extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal (e) {
    e.preventDefault();
    this.setState({
      showModal: !this.state.showModal
    });
  }

  render () {
    return (
      <div>
        <FormattedMessage
          id='inbox.variable_pricing_tooltip.combined_price'
          defaultMessage='This is a combined price based on the listing’s hourly rates and attendee pricing.'
        />&nbsp;
        <button onClick={this.toggleModal} className="btn-link no-gutter" type="button">
          <FormattedMessage
            id='inbox.variable_pricing_tooltip.pricing_rules'
            defaultMessage='View Pricing Rules'
          />
        </button>
        <BootstrapModal
          modalClass="VariablePricingModal"
          header={<h2 className="pricing-table-header">
            <FormattedMessage
              id='inbox.variable_pricing_tooltip.pricing_rules_header'
              defaultMessage='Pricing Rules'
            />
          </h2>}
          body={
            <div>
              <VariablePricingTable
                listing={this.props.listing}
                rateDetails={this.props.rateDetails}
              />
              <div className="show-all-container collapsed">
                <div className="group-bottom">
                  <div style={{ height: '40px' }} className="faded" />
                </div>
              </div>
            </div>
          }
          modalSize="sm-size"
          footer={<div>&nbsp;</div>}
          showModal={this.state.showModal}
        />
      </div>
    );
  }
}

VariablePricingTooltip.propTypes = {
  listing: PropTypes.object.isRequired,
  rateDetails: PropTypes.object
};
